import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, ActivatedRoute } from '@angular/router';

import 'rxjs/add/operator/map';
import { Observable } from 'rxjs/Observable';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { AlertService } from './../alert/alert.service';
import { AppConfig } from '../app-config';

@Injectable()
export class AffiliateGuard implements CanActivate {

    private appConfig: AppConfig = new AppConfig();
    private result: boolean = true;

    constructor(
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private alert: AlertService,
        private localStorage: AsyncLocalStorage
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> | boolean {

        return this.getResult();
    }

    private goToUrl() {
        this.localStorage.getItem('token').subscribe((token) => {
            window.location.href = `${this.appConfig.assine_host}?_p=${token}`;
        });
    }

    getResult(): Observable<any> {
    
        return this.localStorage.getItem('user').map(user => {
            if (user.loga == 0) {
                this.goToUrl();
                return false;
            }
            this.router.navigate(['/pages/dashboard']);
            if(user.cidade == 0) {
                // this.alert.swalWarning(
                //     "Aviso", 
                //     "O Indique e ganhe ainda não está disponível em sua cidade."
                // ).then(() => {
                //     this.router.navigate(['/pages/dashboard']);
                // });
                return false;
            }

            return true;
        });

        //return Observable.of(this.result);
    }
}


// WEBPACK FOOTER //
// /var/www/minha-at3-cliente/src/app/guards/affiliate.guard.ts